var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bem(),staticStyle:{"padding-top":"8px"}},[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":function($event){$event.preventDefault();return _vm.clear($event)}}},[_c('v-icon',[_vm._v("clear")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }